import { IconButton } from "@circle-react-uikit/HeaderV3/IconButton";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { Icon } from "@/react/components/shared/Icon";

import { NoPostsStateV4 } from "./NoPostsStateV4";

interface NoPostsStateProps {
  onCollapseClick: () => void;
}

export const NoPostsState = (props: NoPostsStateProps) => {
  const { isCircleV4 } = useCircleV4();
  if (isCircleV4) return <NoPostsStateV4 {...props} />;
  return <NoPostsStateLegacy {...props} />;
};

const NoPostsStateLegacy = ({ onCollapseClick }: NoPostsStateProps) => (
  <div className="absolute inset-0 flex items-center justify-center p-6">
    <IconButton
      name="20-close"
      iconSize={20}
      onClick={onCollapseClick}
      variant="secondary"
      ariaLabel={t("collapse")}
      className={classNames(
        "bg-primary !border-primary absolute right-5 top-5 z-50 rounded-full border",
      )}
    />

    <div className="animate-fade-in-slow flex h-full items-center justify-center p-6 opacity-0">
      <div className="flex flex-col items-center gap-4 text-center">
        <Icon type="48-sun" size={48} className="scale-[2.5]" />
        <div className="space-y-2">
          <Typography.TitleMd>
            {t("ai_spaces_summaries.all_caught_up")}
          </Typography.TitleMd>
          <div className="max-w-[280px]">
            <Typography.BodySm color="text-default dark:text-dark">
              {t("ai_spaces_summaries.no_posts_found")}
            </Typography.BodySm>
          </div>
        </div>
      </div>
    </div>
  </div>
);
